import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Chip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import BDrawer from '@ui/components/common/BDrawer';
import { centeredRowStack } from '@ui/style/style';
import { AttendeeFilter, EmailRecipientGroup } from '@application/features/emailTemplateSettings/models/email-template-settings-recipient-group-record';
import { EmailTemplateType } from '@application/features/emailTemplates/models/email-template-type';
const RunEmailDialog = ({ open, onClose, onConfirm, isLoading, recipientGroups, templateType }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const getRecipientGroupLabel = (group) => {
        switch (group) {
            case EmailRecipientGroup.AttendeesConfirmed:
                return t('events.eventDetails.preferencesTab.registeredAttendees');
            case EmailRecipientGroup.AttendeesNotRegistered:
                return t('events.eventDetails.preferencesTab.notRegisteredAttendees');
            case EmailRecipientGroup.AttendeesAndGuests:
                return t('events.eventDetails.preferencesTab.registeredAttendeesWithFamilyGuest');
            case EmailRecipientGroup.RegisteredRSVP:
                return t('events.eventDetails.preferencesTab.rsvpRegisteredLabel');
            default:
                return String(group);
        }
    };
    const getAttendeeFilterLabel = (filter) => {
        switch (filter) {
            case AttendeeFilter.All:
                return t('events.eventDetails.preferencesTab.allAttendees');
            case AttendeeFilter.RsvpOnly:
                return t('events.eventDetails.preferencesTab.rsvpInvitedLabel');
            case AttendeeFilter.AttendeesOnly:
                return t('events.eventDetails.preferencesTab.attendeeOnly');
            default:
                return String(filter);
        }
    };
    const actionButtons = (_jsxs(Box, { sx: centeredRowStack, width: '100%', gap: 1, children: [_jsx(Button, { fullWidth: true, variant: 'outlined', color: 'inherit', onClick: onClose, disabled: isLoading, children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'error', onClick: onConfirm, disabled: isLoading, children: isLoading ? t('actions.sending') : t('events.eventDetails.preferencesTab.runAndSend') })] }));
    const dialogBody = (_jsxs(Box, { px: 3, py: 2, children: [_jsx(Typography, { variant: 'body1', color: 'text.primary', mb: 1, children: t('events.eventDetails.preferencesTab.runTriggerDescription') }), recipientGroups && recipientGroups.length > 0 && (_jsxs(Box, { mb: 2, children: [_jsxs(Typography, { variant: 'body2', color: 'text.secondary', mb: 1, children: [t('events.eventDetails.preferencesTab.recipientGroups', 'Recipient Groups'), ":"] }), _jsx(Box, { display: 'flex', flexWrap: 'wrap', gap: 1, children: recipientGroups.map((rg) => {
                            const showFilter = templateType === EmailTemplateType.Invitation ||
                                templateType === EmailTemplateType.ReInvitationReminder;
                            const label = showFilter
                                ? `${getAttendeeFilterLabel(rg.attendeeFilter)}`
                                : getRecipientGroupLabel(rg.recipientGroup);
                            return (_jsx(Chip, { label: label, size: 'small', variant: 'soft', color: 'info' }, rg.id));
                        }) })] })), _jsx(Typography, { variant: 'body1', color: 'text.primary', children: t('events.eventDetails.preferencesTab.runTriggerConfirm') })] }));
    if (isMobile) {
        return (_jsx(BDrawer, { anchor: 'bottom', open: open, onClose: onClose, title: t('events.eventDetails.preferencesTab.runTriggerEmail'), showCloseButton: true, dialogActions: actionButtons, children: dialogBody }));
    }
    return (_jsx(CustomDialog, { open: open, onClose: onClose, backgroundVariant: 'white', titleWithIcon: t('events.eventDetails.preferencesTab.runTriggerEmail'), titleIcon: '/assets/images/addAttendee.png', actions: actionButtons, children: dialogBody }));
};
export default RunEmailDialog;
